﻿(function () {
    'use strict';

    var canvas = document.getElementById('heroNetworkCanvas');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var INK = '43,42,116';
    var W, H, nodes, edges, loops;
    var lastTs = 0;

    // All ry values shifted up by 0.04 to vertically centre the network
    var NODE_DEFS = [
        { rx: 0.18, ry: 0.31, type: 'small', label: 'Docs' }, // 0
        { rx: 0.50, ry: 0.18, type: 'hub', label: 'O&M' }, // 1
        { rx: 0.78, ry: 0.38, type: 'hub', label: 'PPM' }, // 2
        { rx: 0.08, ry: 0.58, type: 'mid', label: 'CRM' }, // 3
        { rx: 0.32, ry: 0.51, type: 'mid', label: 'Projects' }, // 4
        { rx: 0.62, ry: 0.61, type: 'mid', label: 'Tenders' }, // 5
        { rx: 0.90, ry: 0.18, type: 'mid', label: 'Auth' }, // 6
        { rx: 0.88, ry: 0.64, type: 'mid', label: 'Cloud' }, // 7
        { rx: 0.42, ry: 0.76, type: 'small', label: 'Risk' }, // 8
        { rx: 0.68, ry: 0.14, type: 'small', label: 'API' }, // 9
        { rx: 0.24, ry: 0.10, type: 'small', label: 'IMS' }, // 10
        { rx: 0.55, ry: 0.44, type: 'small', label: 'Performance' }, // 11
        { rx: 0.14, ry: 0.78, type: 'hub', label: 'SCM' }, // 12
        { rx: 0.38, ry: 0.14, type: 'small', label: 'BIM' }, // 13
        { rx: 0.72, ry: 0.78, type: 'small', label: 'Assets' }, // 14
        { rx: 0.96, ry: 0.46, type: 'small', label: 'Mobile' }, // 15
        { rx: 0.04, ry: 0.41, type: 'small', label: 'PC' }, // 16
        { rx: 0.58, ry: 0.84, type: 'small', label: 'Sync' }, // 17
        { rx: 0.84, ry: 0.84, type: 'small', label: 'Reports' }, // 18
        { rx: 0.28, ry: 0.86, type: 'small', label: 'Audit' }, // 19
    ];

    var LOOP_ROUTES = [
        [0, 3, 12, 19, 8, 4, 0],
        [1, 9, 6, 2, 11, 5, 14, 2, 1],
        [0, 10, 13, 1, 4, 8, 17, 5, 2, 7, 18, 14, 2],
        [1, 6, 15, 7, 18, 14, 5, 11, 2, 1],
    ];

    function resize() {
        var rect = canvas.parentElement.getBoundingClientRect();
        W = rect.width;
        H = rect.height;
        var dpr = (window.devicePixelRatio && isFinite(window.devicePixelRatio)) ? window.devicePixelRatio : 1;
        canvas.width = Math.round(W * dpr);
        canvas.height = Math.round(H * dpr);
        canvas.style.width = W + 'px';
        canvas.style.height = H + 'px';
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        if (dpr !== 1) ctx.scale(dpr, dpr);
        buildScene();
    }

    function buildScene() {
        loops = null;

        nodes = NODE_DEFS.map(function (d) {
            var r = d.type === 'hub' ? 18 : d.type === 'mid' ? 10 : 5;
            var bx = W * d.rx;
            var by = H * d.ry;
            return {
                bx: bx, by: by, x: bx, y: by, r: r,
                type: d.type, label: d.label,
                phase: Math.random() * Math.PI * 2,
                amp: d.type === 'hub' ? 6 : d.type === 'mid' ? 9 : 10,
                spd: 0.00025 + Math.random() * 0.00030
            };
        });

        var edgeSet = {};
        edges = [];

        function addEdge(i, j) {
            var a = Math.min(i, j), b = Math.max(i, j);
            var key = a + '_' + b;
            if (!edgeSet[key]) {
                edgeSet[key] = true;
                edges.push({ i: a, j: b });
            }
        }

        LOOP_ROUTES.forEach(function (route) {
            for (var s = 0; s < route.length - 1; s++) addEdge(route[s], route[s + 1]);
        });

        for (var i = 0; i < nodes.length; i++) {
            for (var j = i + 1; j < nodes.length; j++) {
                var dx = nodes[i].bx - nodes[j].bx;
                var dy = nodes[i].by - nodes[j].by;
                var d = Math.sqrt(dx * dx + dy * dy);
                var lim = (nodes[i].type === 'hub' || nodes[j].type === 'hub') ? W * 0.38
                    : (nodes[i].type === 'mid' || nodes[j].type === 'mid') ? W * 0.26
                        : W * 0.18;
                if (d < lim) addEdge(i, j);
            }
        }

        buildLoops();
    }

    function buildLoops() {
        loops = LOOP_ROUTES.map(function (route, li) {
            return {
                route: route,
                leg: 0,
                t: li * 0.25,
                speed: 0.00045 + li * 0.00010,
                r: 3.8 - li * 0.25
            };
        });
    }

    function bezierPt(ni, nj, t) {
        var canonical = ni < nj;
        var a = nodes[canonical ? ni : nj];
        var b = nodes[canonical ? nj : ni];
        var tt = canonical ? t : 1 - t;
        var mx = (a.x + b.x) / 2 + (b.y - a.y) * 0.15;
        var my = (a.y + b.y) / 2 - (b.x - a.x) * 0.15;
        var u = 1 - tt;
        return {
            x: u * u * a.x + 2 * u * tt * mx + tt * tt * b.x,
            y: u * u * a.y + 2 * u * tt * my + tt * tt * b.y
        };
    }

    function draw(ts) {
        requestAnimationFrame(draw);
        var dt = Math.min(ts - lastTs, 32);
        lastTs = ts;
        ctx.clearRect(0, 0, W, H);

        nodes.forEach(function (n) {
            n.x = n.bx + Math.sin(ts * n.spd + n.phase) * n.amp;
            n.y = n.by + Math.cos(ts * n.spd * 0.8 + n.phase + 1) * n.amp * 0.7;
        });

        edges.forEach(function (e) {
            var a = nodes[e.i], b = nodes[e.j];
            var dx = a.x - b.x, dy = a.y - b.y;
            var d = Math.sqrt(dx * dx + dy * dy);
            var alpha = Math.max(0.07, 1 - d / (W * 0.55)) * 0.13;
            var mx = (a.x + b.x) / 2 + (b.y - a.y) * 0.15;
            var my = (a.y + b.y) / 2 - (b.x - a.x) * 0.15;
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.quadraticCurveTo(mx, my, b.x, b.y);
            ctx.strokeStyle = 'rgba(' + INK + ',' + alpha + ')';
            ctx.lineWidth = 1;
            ctx.stroke();
        });

        ctx.save();
        ctx.globalAlpha = 0.025;
        ctx.strokeStyle = 'rgb(' + INK + ')';
        ctx.lineWidth = 1;
        var gs = 40;
        for (var gx = 0; gx < W + gs; gx += gs) {
            ctx.beginPath(); ctx.moveTo(gx, 0); ctx.lineTo(gx, H); ctx.stroke();
        }
        for (var gy = 0; gy < H + gs; gy += gs) {
            ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(W, gy); ctx.stroke();
        }
        ctx.restore();

        ctx.save();
        ctx.setLineDash([3, 9]);
        var ax = W * 0.97, ay = H * 0.06;
        [70, 110, 155].forEach(function (rad, i) {
            ctx.beginPath();
            ctx.arc(ax, ay, rad, Math.PI * 0.45, Math.PI * 1.30);
            ctx.strokeStyle = 'rgba(' + INK + ',' + (0.11 - i * 0.03) + ')';
            ctx.lineWidth = 1.2;
            ctx.stroke();
        });
        ctx.setLineDash([]);
        ctx.restore();

        if (loops) {
            loops.forEach(function (lp) {
                lp.t += lp.speed * (dt / 16);
                if (lp.t >= 1) {
                    lp.t = lp.t - 1;
                    lp.leg = (lp.leg + 1) % (lp.route.length - 1);
                }
                var ni = lp.route[lp.leg];
                var nj = lp.route[lp.leg + 1];
                if (!nodes[ni] || !nodes[nj]) return;
                var pt = bezierPt(ni, nj, lp.t);
                var fade = lp.t < 0.10 ? lp.t / 0.10
                    : lp.t > 0.90 ? (1 - lp.t) / 0.10
                        : 1;
                ctx.beginPath();
                ctx.arc(pt.x, pt.y, lp.r, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(' + INK + ',' + (0.35 * fade) + ')';
                ctx.fill();
            });
        }

        nodes.forEach(function (n) {
            if (n.type === 'hub') {
                var pulse = 0.5 + 0.5 * Math.sin(ts * 0.0007 + n.phase);
                ctx.beginPath();
                ctx.arc(n.x, n.y, n.r + 6 + pulse * 5, 0, Math.PI * 2);
                ctx.strokeStyle = 'rgba(' + INK + ',' + (0.06 + pulse * 0.05) + ')';
                ctx.lineWidth = 1.5;
                ctx.stroke();
            }
            ctx.beginPath();
            ctx.arc(n.x, n.y, n.r, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(' + INK + ',' + (n.type === 'hub' ? 0.10 : n.type === 'mid' ? 0.07 : 0.05) + ')';
            ctx.fill();
            ctx.strokeStyle = 'rgba(' + INK + ',' + (n.type === 'hub' ? 0.38 : n.type === 'mid' ? 0.22 : 0.15) + ')';
            ctx.lineWidth = n.type === 'hub' ? 1.5 : 1;
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(n.x, n.y, n.r * 0.28, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(' + INK + ',' + (n.type === 'hub' ? 0.48 : 0.22) + ')';
            ctx.fill();
            ctx.font = (n.type === 'hub' ? '600' : '500') + ' ' + (n.type === 'hub' ? 9 : 8) + 'px sans-serif';
            ctx.fillStyle = 'rgba(' + INK + ',' + (n.type === 'hub' ? 0.55 : 0.42) + ')';
            ctx.textAlign = 'center';
            ctx.fillText(n.label, n.x, n.y + n.r + 11);
        });

        var sy = (ts * 0.020) % H;
        var sg = ctx.createLinearGradient(0, 0, W, 0);
        sg.addColorStop(0, 'rgba(' + INK + ',0)');
        sg.addColorStop(0.5, 'rgba(' + INK + ',0.018)');
        sg.addColorStop(1, 'rgba(' + INK + ',0)');
        ctx.fillStyle = sg;
        ctx.fillRect(0, sy, W, 1.5);
    }

    resize();
    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(resize, 120);
    });
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.matches) { resize(); draw(0); return; }
    requestAnimationFrame(draw);
}());